<template>
	<div class="contactus_box">
		<section class="header-container-bg" style="min-height: 255px;">
			<div class="container-1200" style="padding-top: 40px;">
				<HeaderVue @indexChange="onIndexChange"></HeaderVue>
			</div>
		</section>
		<section class="container-1200 layui-fluid">
			<div class="layui-row" v-if="activeIndex == 0">
				<div class="contactus_left">
					<div class="left_title">Headquarter</div>
					<div class="left_content">
						<div>
							<p>8 Eu Tong Sen Street,#16-81,</p>
							<p>The Central,Singapore 059818</p>
						</div>
					</div>
					<div class="left_email">
						<div class="email_item">
							Email: <a href="mailto:contact@contrimetric.com?subject=&body=">
								contact@contrimetric.com</a>
						</div>

						<div class="email_item">
							Phone: <a href="tel:+1 949 792 8737"> +1 949 792 8737</a>
						</div>

						<div class="email_item">
							Contrimetric Pte. Ltd.
						</div>

						<div class="email_item">
							Register No.202335082Z
						</div>

						<div class="email_item">
							UEN: 202501559W
						</div>

						<div class="email_item">
							<MediaLinks></MediaLinks>
						</div>

						<div class="email_item">
							<el-button type="primary" class="levame_btn" @click="openLeaveMessageDialog">Send us a
								message
							</el-button>
						</div>
					</div>
				</div>

				<div class="layui-col-md6" style="margin-top: 80px;">
					<img :src="require('@/assets/images/contact.jpg')" style="width: 100%;" />
				</div>
			</div>

			<PressResourcesVue v-if="activeIndex == 1"></PressResourcesVue>
			<SupportVue v-if="activeIndex == 2"></SupportVue>
			<LeaveMessageDialog ref="leaveMessageDialogRef"></LeaveMessageDialog>
		</section>
	</div>
</template>

<script>
import HeaderVue from "./components/header.vue"
import PressResourcesVue from "./pressResources.vue";
import SupportVue from "./support.vue";
import MediaLinks from "@/components/mediaLinks/index.vue"
import LeaveMessageDialog from "./leaveMessageDialog.vue";

export default {
	name: "contactus",
	components: {
		HeaderVue,
		PressResourcesVue,
		SupportVue,
		MediaLinks,
		LeaveMessageDialog
	},
	data() {
		return {
			activeIndex: 0
		}
	},
	methods: {
		onIndexChange(index) {
			this.activeIndex = index
		},
		openLeaveMessageDialog() {
			this.$refs.leaveMessageDialogRef.openDialog()
		}
	},
	mounted() {
		if (this.$route.query.index) {
			this.onIndexChange(this.$route.query.index)
		}
	}
}
</script>

<style scoped lang="scss">

.navContent{
	min-height: unset !important;

}

.header-container-bg{
	background-image: url("../../assets/images/contact/faqBg.png");
	background-repeat: no-repeat;
}

.layui-fluid{
	margin-bottom: 40px;
}

.contactus_box {

	
	.layui-row {
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.contactus_left {
		font-family: none;
	}

	.contactus_left .left_title {
		font-size: 38px;
		margin-bottom: 50px;
	}

	.contactus_left .left_content,
	.contactus_left .left_email {
		color: #606060;
		font-size: 16px;
		display: flex;
		flex-direction: column;
		align-items: baseline;
	}

	.left_email {
		gap: 6px;
	}

	.email_item {
		display: flex;
		align-items: center;

		.levame_btn {
			transition: all .3s;

			&:hover {
				background-color: transparent;
				color: #1da6b8;
			}
		}
	}

	.contactus_left .left_content {
		line-height: 28px;
	}

	.contactus_left .left_email {
		display: flex;
		margin-top: 24px;
	}

	.contactus_left .left_email a {
		color: black;
		text-decoration: underline;
		margin-left: 10px;
	}

	.header_content {
		margin-top: 30px;
		line-height: 26px;
		display: flex;
		justify-content: space-between;
	}

	.header_content1 {
		flex: 1;
		margin-right: 30px;
		border-radius: 20px;
		height: 300px;
		display: flex;
		background-color: #074463;
		justify-content: center;
		align-items: center;
	}

	a {
		display: flex;
		flex-direction: column;
		text-decoration: none;
		text-align: center;
		justify-content: center;
		align-items: center;
		color: white;
	}

	.header_content1 img {
		width: 60px;
		height: 60px;
		margin-bottom: 15px;
	}


	.header_content1:hover {
		background-color: #fff;
		color: black;
		box-shadow: 0 0 100px 0 rgba(0, 0, 0, .3)
	}

	.header_content1:hover img {
		border-radius: 50px;
		background-color: #1F79A8;
	}
}

@media (max-width: 768px) {
	.contactus_box {
		.layui-row {
			margin-top: 20px;

			.left_title {
				font-size: 26px;
				margin-bottom: 20px;
			}

			.left_content {
				font-size: 16px;
			}

			.layui-col-md6 {
				display: none;
			}
		}
	}
}
</style>